import actionBuilder from 'store/v2/actions';
import actionType, { bulkActionType, apiPath } from './constants';

const actions = actionBuilder({ apiPath, bulkActionType, actionType });

export default actions;
